module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.ce792ace.woff2";